var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Edit = forwardRef(function (props, ref) { return (_jsxs(StyledIcon, __assign({ ref: ref, viewBox: "0 0 20 21", a11yTitle: "Edit" }, props, { children: [_jsx("path", { d: "M1.47412 12.5814C1.11314 12.9424 0.752149 13.6523 0.679952 14.1698L0.162537 17.7917C-0.0299891 19.1032 0.896545 20.0177 2.20813 19.8373L5.83003 19.3198C6.33542 19.2476 7.04536 18.8867 7.41838 18.5257L16.9003 9.04374C18.5368 7.40726 19.3069 5.50606 16.9003 3.09948C14.4937 0.692901 12.5925 1.46301 10.9561 3.09948L1.47412 12.5814Z", stroke: "#000", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M11.1726 4.94067C11.6997 6.82099 13.1709 8.2922 15.0591 8.82719", stroke: "#000", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }))); });
//# sourceMappingURL=Edit.js.map